module.exports = __webpack_public_path__ + "static/sclub-35beb5efbfb372eba813791bd5274077.jpg";